export default __webpack_public_path__ + "static/media/right-img.d08b6fec.svg";